import { useState } from "react";
import { faqItems } from "@/mocks/gossip";

export default function FaqSection() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section id="faq" className="scroll-mt-20 bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid gap-8 lg:grid-cols-3 lg:gap-10">
          <div>
            <div className="mb-2 flex items-center gap-2 text-sm font-semibold text-primary-600">
              <i className="ri-questionnaire-line"></i>
              常见问题
            </div>
            <h2 className="font-heading text-3xl font-black tracking-tight text-foreground-950 md:text-4xl">
              关于吃瓜，
              <br className="hidden lg:block" />
              你可能想问
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              关于信息来源、反转口径、辟谣标准与投稿方式，我们整理了读者最关心的问题统一解答。
            </p>
            <a
              href="mailto:hello@bage-chigua.cn"
              className="mt-6 inline-flex items-center gap-2 rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold whitespace-nowrap text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-mail-line"></i>
              还有疑问，联系我们
            </a>
          </div>

          <div className="flex flex-col gap-3 lg:col-span-2">
            {faqItems.map((f, i) => {
              const open = openIdx === i;
              return (
                <div
                  key={i}
                  className="overflow-hidden rounded-xl border border-background-200 bg-background-50"
                >
                  <button
                    onClick={() => setOpenIdx(open ? null : i)}
                    className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                  >
                    <span className="flex items-center gap-3">
                      <span
                        className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-xs font-bold ${
                          open ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-600"
                        }`}
                      >
                        {i + 1}
                      </span>
                      <h3 className="text-sm font-semibold text-foreground-950 md:text-base">{f.q}</h3>
                    </span>
                    <i
                      className={`shrink-0 text-lg text-foreground-500 transition-transform ${open ? "rotate-45" : ""} ri-add-line`}
                    ></i>
                  </button>
                  {open && (
                    <div className="border-t border-background-200 bg-background-100/60 px-5 py-4">
                      <p className="pl-9 text-sm leading-relaxed text-foreground-700">{f.a}</p>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}